// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36m9G","label":"styles_label__hwWZb"};